import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getSupplierDebtEquity = createAsyncThunk(
  'alix/get-supplier-debt-equity',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/debt-equity-ratio?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierZscoreRevenue = createAsyncThunk(
  'alix/get-supplier-zscore-revenue',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/zscore-revenue?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierKpiCardData = createAsyncThunk(
  'alix/get-supplier-kpi-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/kpi?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierRevenueAndMarginData = createAsyncThunk(
  'alix/get-supplier-revenue-and-margin-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/revenue-margin?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getSupplierLiquidityRatiosData = createAsyncThunk(
  'alix/get-supplier-liquidity-ratios-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/liquidity-ratio?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getFinanceKPIData = createAsyncThunk(
  'alix/finance-kpi-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/kpi?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getFinanceRiskScoreGraphData = createAsyncThunk(
  'alix/finance-risk-graph-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/finance-risk-score-graph?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getFinanceQuarterlyRevenueAndProfitData = createAsyncThunk(
  'alix/finance-quarterly-revenue-and-profit-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/revenue-margin?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)

export const getFinanceQuarterlyLiquidityRatiosData = createAsyncThunk(
  'alix/finance-quarterly-liquidity-ratios-data',
  async (payload, toolkit) => {
    return await AxiosClient(
      'GET',
      `/v1/risk-management/finance-scoreboard/liquidity-ratio?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
      {},
      toolkit,
    )
  },
)
